export default {
  name: 'PageHeader',
  data () {
    return {
    }
  },
  mounted: function() {
    let self = this;
    window.addEventListener("resize", function(event) {
    	self.close_all_menu();
    	document.getElementsByTagName("body")[0].classList.remove("display_menu");
    });
  },
  methods: {
		display_menu : function(){
			var body = document.getElementsByTagName("body")[0];
			(!body.classList.contains("display_menu")) ? body.classList.add("display_menu") : body.classList.remove("display_menu");
		},
		display_drop_menu : function(){
			var drop_menu = event.target.parentElement.getElementsByClassName("drop_menu")[0];
			var drop_menus = document.getElementsByClassName("drop_menu");

			Array.from(drop_menus).forEach(function(e){
				if(e != drop_menu){
					e.classList.remove("display");
				}
			});
			var lis = document.getElementById("menu").getElementsByTagName("li");
			Array.from(lis).forEach(function(e){
				e.style.marginTop = 0;
			});
			(!drop_menu.classList.contains("display")) ? drop_menu.classList.add("display") : drop_menu.classList.remove("display");
			if(window.innerWidth < 660 && drop_menu.classList.contains("display")) {
				event.target.parentElement.nextSibling.nextSibling.style.marginTop = drop_menu.clientHeight + "px";
      }
		},
    close_all_menu : function(){
    	var lis = document.getElementById("menu").getElementsByTagName("li");
    	Array.from(lis).forEach(function(e){
    		e.style.marginTop = 0;
    	});
    	var drop_menus = document.getElementsByClassName("drop_menu");
    	Array.from(drop_menus).forEach(function(e){
    		e.classList.remove("display");
    	});
    }
  },
  computed: {
  },
  watch: {
    '$route' (to, from) {
      this.$forceUpdate()
      this.display_menu()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/global/pageHeader/pageHeader.component.js